import { TableHeadersType } from '../tableHeadersType';

export const HOLIDAY_CALENDER_HEADERS: TableHeadersType[] = [
  {
    "label": "Country",
    "value": "country",
  
  },
  {
    "label": "Description",
    "value": "description",
  
  },
  {
    "label": "Branch",
    "value": "branch",
  
  },
  {
    "label": "Date",
    "value": "date",
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
  },
  {
    "label": "ACTION",
    "value": "Edit",
  },
 
];

